<div class="gpd-full-page">
  <!----------- Custom Responsive Toolbar ---------------------------------->
  <div class="task-toolbar-wrapper">
    <div class="task-toolbar-primary">
      <dx-text-box
        [value]="searchValue"
        [showClearButton]="true"
        i18n-placeholder="@@projectTasksSearch"
        placeholder="Search tasks..."
        valueChangeEvent="keyup"
        (onValueChanged)="searchValueChanged($event)"
        style="border-radius: 8px; border-color: var(--color-grey-300)"
        [mode]="'search'"
        width="250px"
      >
      </dx-text-box>
      <app-gpd-segmented-switch
        class="task-toolbar-switch"
        [options]="expandOptions"
        [value]="expandedLevel"
        (valueChange)="setExpandLevel($event)"
      ></app-gpd-segmented-switch>
    </div>
    <div class="task-toolbar-filters">
      <div class="task-toolbar-status-pills">
        <gpd-filter
          i18n-text="@@filter"
          text="Filter"
          [(value)]="taskFilterValue"
          [options]="taskFilterOptions"
          [multiple]="true"
          [nullable]="true"
          [disableAll]="true"
          [disableSearch]="true"
          subtitleExpr="subtitle"
          [activeWhenNotEmpty]="true"
        ></gpd-filter>
        <app-status-filter
          *ngFor="let filter of filters"
          [id]="filter.value.id"
          [label]="filter.value.text"
          [indicatorColor]="filter.color"
          [indicatorBorderColor]="filter.borderColor"
          [count]="getTaskCount(filter.value.id)"
          [selected]="filterStyle == filter.value.id"
          [hashed]="filter.hashed"
          (filterChange)="filterByStatus($event)"
        ></app-status-filter>
      </div>
      <div class="task-toolbar-actions">
        <dx-drop-down-button
          i18n-text="@@exports"
          text="Exports"
          displayExpr="name"
          itemTemplate="exportItem"
          class="gpd-button gpd-button-secondary export-button"
          [items]="downloadDocumentOptions"
          [width]="'max-content'"
          (onItemClick)="handleExportButtonClick($event)"
          [dropDownOptions]="{ width: '300px' }"
        >
          <div *dxTemplate="let item of 'exportItem'" class="export-item">
            <app-svg-icon [icon]="item.icon" [size]="18" [strokeWidth]="1.5" color="var(--color-grey-900)"></app-svg-icon>
            <span>{{ item.name }}</span>
          </div>
        </dx-drop-down-button>
      </div>
    </div>
  </div>

  <dx-tree-list
    #taskList
    class="task-list"
    [dataSource]="tasks"
    dataStructure="plain"
    [expandedRowKeys]="expandedRowKeys"
    (onRowExpanded)="onRowExpanded($event)"
    (onRowCollapsed)="onRowCollapsed($event)"
    keyExpr="taskId"
    parentIdExpr="parentId"
    [showRowLines]="true"
    (onRowPrepared)="onRowPrepared($event)"
    (onCellPrepared)="onCellPrepared($event)"
    [searchPanel]="{ visible: false }"
    loadPanel="visible"
    [hoverStateEnabled]="true"
    [sorting]="false"
    [repaintChangesOnly]="true"
    (onEditingStart)="onEditingStart($event)"
    (onRowClick)="changeSelectedRow($event)"
    columnResizingMode="widget"
    [allowColumnResizing]="true"
    filterMode="withAncestors"
    [columnAutoWidth]="false"
    [showBorders]="true"
    [height]="'100%'"
  >
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-editing mode="cell" [allowUpdating]="true" startEditAction="click"></dxo-editing>
    <dxo-export [enabled]="true" [formats]="['xlsx', 'pdf']"></dxo-export>
    <dxo-scrolling
      mode="standard"
      [useNative]="true"
      rowRenderingMode="standard"
      columnRenderingMode="virtual"
    ></dxo-scrolling>

    <!----------- End Toolbar ---------------------------------->

    <!----------- Title Column --------------------------------->
    <dxi-column
      dataField="title"
      i18n-caption="@@title"
      caption="Title"
      [allowEditing]="false"
      [allowFiltering]="false"
      cellTemplate="titleCellTemplate"
      [minWidth]="150"
      [allowResizing]="true"
    >
      <div class="title-cell-template" *dxTemplate="let item of 'titleCellTemplate'">
        <span class="site-task-icon-wrapper" *ngIf="item.data.grid == true">
          <app-svg-icon icon="location" [size]="18" [strokeWidth]="1.5" class="icon"></app-svg-icon>
          <span class="site-task-tooltip" i18n="@@siteTask">Site Task</span>
        </span>
        <div
          [title]="item.data.title"
          [innerHTML]="item.data.title"
          *ngIf="item.data.helpLink == null"
          class="title-container"
          [style.margin-left]="item.data.grid != true && item.data.type != 'group' ? '23px' : '0px'"
        ></div>
        <div
          *ngIf="item.data.helpLink != null"
          class="title-container-wiki"
          [style.margin-left]="item.data.grid != true && item.data.type != 'group' ? '23px' : '0px'"
        >
          <span [title]="item.data.title" [innerHTML]="item.data.title" class="title-container-wiki-content"> </span>
          <dx-button class="task-wiki-cell-btn" text icon="info" (click)="getWikiArticle(item.data.helpLink)">
          </dx-button>
        </div>
      </div>
    </dxi-column>

    <!----------- Status Column --------------------------------->
    <dxi-column
      dataField="status"
      i18n-caption="@@status"
      caption="Status"
      editCellTemplate="statusEditTemplate"
      cellTemplate="statusTemplate"
      [allowFiltering]="false"
      alignment="left"
      [allowResizing]="true"
      [width]="200"
    >
      <!-- Display only; the select box below is built when the cell is clicked (no showEditorAlways:
           one select box per row made expanding to "Aufgaben" take seconds). -->
      <div *dxTemplate="let item of 'statusTemplate'">
        <div class="status-item-container cell-dropdown-display" *ngIf="item.data.type != 'group'">
          <app-status-pill [statusId]="item.data.status" [statusConfig]="taskStatusConfig" />
          <app-svg-icon icon="chevron-down" [size]="14" [strokeWidth]="1.5" class="icon"></app-svg-icon>
        </div>
      </div>
      <div *dxTemplate="let item of 'statusEditTemplate'">
        <dx-select-box
          *ngIf="item.data.type != 'group'"
          (onInitialized)="openEditorDropDown($event)"
          [dataSource]="statesComboBox"
          [(value)]="item.data.status"
          valueExpr="id"
          displayExpr="text"
          (onValueChanged)="changeStatus($event, item.data)"
          itemTemplate="itemTemplate"
          fieldTemplate="fieldTemplate"
          [showDropDownButton]="true"
          style="background: none"
          dropDownButtonTemplate="customDropDownIcon"
        >
          <div *dxTemplate="let data of 'customDropDownIcon'">
            <app-svg-icon icon="chevron-down" [size]="14" [strokeWidth]="1.5" class="icon"></app-svg-icon>
          </div>
          <div *dxTemplate="let data of 'fieldTemplate'">
            <div class="status-item-container">
              <dx-text-box style="display: none"></dx-text-box>
              <app-status-pill [statusId]="$safeNavigationMigration(data?.id)" [statusConfig]="taskStatusConfig" />
            </div>
          </div>

          <div *dxTemplate="let data of 'itemTemplate'">
            <div class="status-item-container">
              <app-status-pill [statusId]="data.id" [statusConfig]="taskStatusConfig" />
            </div>
          </div>
        </dx-select-box>
      </div>
    </dxi-column>

    <!----------- Role Column --------------------------------->
    <!--dxi-column dataField="role" i18n-caption="@@role" caption="Role" [width]="'80px'" [minWidth]="100"
      [allowEditing]="false" [allowFiltering]="true" [allowResizing]="true">
    </dxi-column-->

    <!----------- Type Column --------------------------------->
    <dxi-column
      dataField="type"
      i18n-caption="@@type"
      caption="Type"
      [width]="'100px'"
      [minWidth]="100"
      [allowEditing]="false"
      [allowFiltering]="true"
      [allowResizing]="true"
      [lookup]="{
        dataSource: typeLookup,
        displayExpr: 'val',
        valueExpr: 'id',
      }"
    >
    </dxi-column>
    <!----------- Department --------------------------------->
    <dxi-column
      dataField="departmentId"
      i18n-caption="@@Department"
      caption="Department"
      cellTemplate="departmentTemplate"
      editCellTemplate="departmentEditTemplate"
      [allowFiltering]="true"
      [allowEditing]="true"
      [width]="'auto'"
      [allowResizing]="true"
      alignment="left"
      [lookup]="{
        dataSource: departments,
        valueExpr: 'id',
        displayExpr: 'name',
        filter: ['name'],
      }"
    >
      <div *dxTemplate="let item of 'departmentTemplate'">
        <!-- #4994: person or department; nobody at all shows the role name, greyed (holder-unassigned) -->
        <span [class.holder-unassigned]="!holderName(item.data)">
          {{ holderName(item.data) || lookupDepartment(item.data.departmentId) }}
        </span>
      </div>
      <div *dxTemplate="let item of 'departmentEditTemplate'">
        <app-holder-select
          [users]="users"
          [departments]="departments"
          [email]="item.data.assignedUserEmail"
          [departmentId]="item.data.assignedDepartmentId"
          [placeholder]="''"
          (holderChange)="departmentChanged(item.data, $event)"
        ></app-holder-select>
      </div>
    </dxi-column>

    <!----------- Result Column --------------------------------->
    <dxi-column
      dataField="taskResult"
      i18n-caption="@@results"
      caption="Results"
      [width]="500"
      editCellTemplate="editCellTemplate"
      [allowFiltering]="false"
      [showEditorAlways]="true"
      [allowResizing]="true"
    >
      <div *dxTemplate="let item of 'editCellTemplate'">
        <ng-container [ngSwitch]="item.data.type">
          <div *ngSwitchCase="'group'"></div>
          <div *ngSwitchCase="'task'">
            <dx-check-box
              [enableThreeStateBehavior]="false"
              [(value)]="item.data.taskResult"
              (onValueChanged)="updateStatus(item.data)"
              [readOnly]="
                item.data.status == StatusData.IN_REVIEW.id ||
                item.data.status == StatusData.DONE.id ||
                item.data.status == StatusData.NOT_REQUIRED.id
              "
            >
            </dx-check-box>
          </div>
          <div *ngSwitchCase="'yes/no'">
            <dx-select-box
              [dataSource]="yesNo"
              displayExpr="name"
              valueExpr="name"
              [readOnly]="
                item.data.status == StatusData.IN_REVIEW.id ||
                item.data.status == StatusData.DONE.id ||
                item.data.status == StatusData.NOT_REQUIRED.id
              "
              [(value)]="item.data.taskResult"
              (onValueChanged)="updateStatus(item.data)"
            >
            </dx-select-box>
          </div>

          <div *ngSwitchCase="'contact'">
            <!-- Once the result is locked the dropdown can no longer be used, so show the
                 contact as a clickable pill instead; keep the editor while it is still open. -->
            <app-contact-pill
              *ngIf="getContactPill(item.data) as contact; else contactEditor"
              [value]="contact"
            ></app-contact-pill>
            <ng-template #contactEditor>
              <div class="contacts-dropdown-box-container">
                <app-contacts-dropdown-box
                  class="test"
                  style="width: 100%"
                  [(contactId)]="item.data.taskResult"
                  [readOnly]="isTaskResultLocked(item.data)"
                  [(contactType)]="item.data.contactType"
                  [(companies)]="companies"
                  [(persons)]="persons"
                  (onContactSelected)="onDropdownContactSelected($event, item)"
                >
                </app-contacts-dropdown-box>
                <dx-button
                  icon="overflow"
                  style="float: right"
                  (onClick)="showContactsPopup(item.data.id); setPopupReturnTarget(item.data)"
                  [disabled]="isTaskResultLocked(item.data)"
                >
                </dx-button>
              </div>
            </ng-template>
          </div>

          <div *ngSwitchCase="'date'">
            <dx-date-box
              type="date"
              applyValueMode="useButtons"
              [(value)]="item.data.taskResult"
              i18n-displayFormat="@@dateFormat"
              displayFormat="dd.MM.yyyy"
              [readOnly]="
                item.data.status == StatusData.IN_REVIEW.id ||
                item.data.status == StatusData.DONE.id ||
                item.data.status == StatusData.NOT_REQUIRED.id
              "
              dateSerializationFormat="yyyy-MM-dd"
              (onValueChanged)="updateStatus(item.data); closeEditCell()"
            >
            </dx-date-box>
          </div>

          <div *ngSwitchCase="'user defined selection'">
            <dx-select-box
              [dataSource]="item.data.userDefinedSelectionOptions"
              [showClearButton]="
                !(
                  item.data.status == StatusData.IN_REVIEW.id ||
                  item.data.status == StatusData.DONE.id ||
                  item.data.status == StatusData.NOT_REQUIRED.id
                )
              "
              [(value)]="item.data.taskResult"
              [readOnly]="
                item.data.status == StatusData.IN_REVIEW.id ||
                item.data.status == StatusData.DONE.id ||
                item.data.status == StatusData.NOT_REQUIRED.id
              "
              (onValueChanged)="updateStatus(item.data)"
            >
            </dx-select-box>
          </div>

          <div *ngSwitchCase="'number'">
            <dx-number-box
              [value]="item.data.taskResult"
              [format]="formatNumber"
              [showClearButton]="
                !(
                  item.data.status == StatusData.IN_REVIEW.id ||
                  item.data.status == StatusData.DONE.id ||
                  item.data.status == StatusData.NOT_REQUIRED.id
                )
              "
              [readOnly]="
                item.data.status == StatusData.IN_REVIEW.id ||
                item.data.status == StatusData.DONE.id ||
                item.data.status == StatusData.NOT_REQUIRED.id
              "
              (onValueChanged)="item.setValue($event.value); updateStatus(item.data); logItemData(item.data)"
              [placeholder]="item.data.note"
            >
            </dx-number-box>
          </div>

          <div *ngSwitchCase="'text'">
            <dx-text-box
              [(value)]="item.data.taskResult"
              [showClearButton]="
                !(
                  item.data.status == StatusData.IN_REVIEW.id ||
                  item.data.status == StatusData.DONE.id ||
                  item.data.status == StatusData.NOT_REQUIRED.id
                )
              "
              [readOnly]="
                item.data.status == StatusData.IN_REVIEW.id ||
                item.data.status == StatusData.DONE.id ||
                item.data.status == StatusData.NOT_REQUIRED.id
              "
              (onValueChanged)="updateStatus(item.data); logItemData(item.data)"
              [placeholder]="item.data.note"
            >
            </dx-text-box>
          </div>

          <div *ngSwitchCase="'note'">
            <dx-text-box
              [(value)]="item.data.taskResult"
              [showClearButton]="
                !(
                  item.data.status == StatusData.IN_REVIEW.id ||
                  item.data.status == StatusData.DONE.id ||
                  item.data.status == StatusData.NOT_REQUIRED.id
                )
              "
              [readOnly]="
                item.data.status == StatusData.IN_REVIEW.id ||
                item.data.status == StatusData.DONE.id ||
                item.data.status == StatusData.NOT_REQUIRED.id
              "
              (onValueChanged)="updateStatus(item.data)"
              [placeholder]="item.data.note"
            >
            </dx-text-box>
          </div>

          <div *ngSwitchCase="'contract'" class="document-detail-box">
            <!-- #1578: fill a managed template for contract tasks, or just download it unfilled -->
            <div class="template-actions" *ngIf="fillTemplateEnabled && item.data.templateDocuments?.length > 0">
              <dx-button
                *ngFor="let template of item.data.templateDocuments"
                class="template-action-button"
                icon="download"
                [hint]="templateDownloadHint(template)"
                (click)="downloadManagedTemplate(template)"
              >
              </dx-button>
              <dx-button
                class="template-action-button"
                icon="doc"
                i18n-hint="@@fillTemplate"
                hint="Fill in template"
                (click)="openFillTemplateForTask(item.data)"
              >
              </dx-button>
            </div>
            <ng-container *ngIf="item.data.taskResult != null; else contractEditCell">
              <ng-container *ngIf="getContractDesignation(item.data.taskResult) != undefined; else noContractFound">
                <div class="document-detail-box">
                  {{ getContractDesignation(item.data.taskResult) }}
                  <dx-button
                    class="download-template-button"
                    icon="search"
                    (onClick)="goToContractDetails(item.data.taskResult)"
                  >
                  </dx-button>
                </div>
              </ng-container>
            </ng-container>
            <ng-template #noContractFound>
              <span class="no-contract-found" i18n="@@noContractFound"> No contract found </span>
            </ng-template>
            <ng-template #contractEditCell>
              <div class="document-detail-box" i18n="@@selectContract">
                Select contract
                <dx-button
                  class="download-template-button"
                  icon="overflow"
                  (onClick)="showContractSelectorPopup(item.data)"
                >
                </dx-button>
              </div>
            </ng-template>
          </div>

          <div *ngSwitchCase="'document'">
            <div
              class="document-detail-box"
              *ngIf="item.data.taskResult != null && item.data.taskResult != ''; else destinationFolder"
            >
              <div class="document-detail-box" *ngIf="item.data.taskResult != null; else destinationFolder">
                <app-document-pill
                  [value]="{
                    id: getDocId(item.data),
                    documentName: getDocFullName(item.data),
                    displayName: getDocName(item.data),
                    type: 'task',
                    externallyModified: isDocExternallyModified(item.data)
                  }"
                ></app-document-pill>
              </div>
            </div>
            <ng-template #destinationFolder>
              <div class="document-detail-box">
                <input
                  *ngIf="item.data.destinationFolder != null; else noFolder"
                  type="file"
                  name="upload"
                  enctype="multipart/form-data"
                  (change)="uploadDocument(item.data, $event)"
                />

                <div class="template-actions">
                  <dx-button
                    *ngIf="item.data.templateFilename != null"
                    class="template-action-button"
                    icon="download"
                    i18n-hint="@@downloadTemplate"
                    hint="Download template"
                    (click)="downloadTemplateDocument(item.data.taskId, item.data.templateFilename)"
                  >
                  </dx-button>

                  <!-- #173: managed templates from the template library -->
                  <dx-button
                    *ngFor="let template of item.data.templateDocuments"
                    class="template-action-button"
                    icon="download"
                    [hint]="templateDownloadHint(template)"
                    (click)="downloadManagedTemplate(template)"
                  >
                  </dx-button>

                  <!-- #1207: fill a managed template for document tasks -->
                  <dx-button
                    *ngIf="fillTemplateEnabled && item.data.templateDocuments?.length > 0"
                    class="template-action-button"
                    icon="doc"
                    i18n-hint="@@fillTemplate"
                    hint="Fill in template"
                    (click)="openFillTemplateForTask(item.data)"
                  >
                  </dx-button>
                </div>

                <ng-template #noFolder i18n="@@noFolderSpecified"> no folder specified </ng-template>
              </div>
            </ng-template>
          </div>
        </ng-container>
      </div>
    </dxi-column>

    <!----------- Priority Column --------------------------------->

    <dxi-column
      dataField="priority"
      i18n-caption="@@priority"
      caption="Priority"
      editCellTemplate="priorityEditTemplate"
      cellTemplate="priorityCellTemplate"
      [allowFiltering]="true"
      alignment="left"
      [allowResizing]="true"
      [width]="120"
      [lookup]="{
        dataSource: priorities,
        valueExpr: 'id',
        displayExpr: 'text',
        filter: ['text'],
      }"
    >
      <!-- Display only, like the Status column: the select box is built on click. -->
      <div *dxTemplate="let item of 'priorityCellTemplate'">
        <div class="status-item-container cell-dropdown-display" *ngIf="item.data.type != 'group'">
          <app-priority-pill
            [value]="item.data.priority"
            [editable]="
              !(
                item.data.status == StatusData.IN_REVIEW.id ||
                item.data.status == StatusData.DONE.id ||
                item.data.status == StatusData.NOT_REQUIRED.id
              )
            "
          />
          <app-svg-icon icon="chevron-down" [size]="14" [strokeWidth]="1.5" class="icon"></app-svg-icon>
        </div>
      </div>
      <div *dxTemplate="let item of 'priorityEditTemplate'">
        <dx-select-box
          *ngIf="item.data.type != 'group'"
          (onInitialized)="openEditorDropDown($event)"
          [dataSource]="priorities"
          [(value)]="item.data.priority"
          (onValueChanged)="saveItem(item.data)"
          itemTemplate="itemTemplate"
          fieldTemplate="fieldTemplate"
          [showDropDownButton]="true"
          style="background: none"
          dropDownButtonTemplate="customDropDownIcon"
          valueExpr="id"
          displayExpr="text"
        >
          <div *dxTemplate="let data of 'customDropDownIcon'">
            <app-svg-icon icon="chevron-down" [size]="14" [strokeWidth]="1.5" class="icon"></app-svg-icon>
          </div>
          <div *dxTemplate="let data of 'fieldTemplate'">
            <div class="status-item-container">
              <dx-text-box style="display: none"></dx-text-box>
              <app-priority-pill
                [value]="data.id"
                [editable]="
                  !(
                    item.data.status == StatusData.IN_REVIEW.id ||
                    item.data.status == StatusData.DONE.id ||
                    item.data.status == StatusData.NOT_REQUIRED.id
                  )
                "
              />
            </div>
          </div>

          <div *dxTemplate="let data of 'itemTemplate'">
            <div class="status-item-container">
              <div *ngIf="item.data.type != 'group'" class="priority-container">
                <app-priority-pill
                  [value]="data.id"
                  [editable]="
                    !(
                      item.data.status == StatusData.IN_REVIEW.id ||
                      item.data.status == StatusData.DONE.id ||
                      item.data.status == StatusData.NOT_REQUIRED.id
                    )
                  "
                />
              </div>
            </div>
          </div>
        </dx-select-box>
      </div>
    </dxi-column>

    <!----------- Tag Column (#4810) ----------------------------->
    <dxi-column
      dataField="tags"
      i18n-caption="@@tag"
      caption="Tag"
      cellTemplate="tagCellTemplate"
      [calculateCellValue]="tagCellValue"
      [calculateFilterExpression]="tagFilterExpression"
      [allowEditing]="false"
      [allowFiltering]="true"
      [allowResizing]="true"
      [width]="200"
      [minWidth]="120"
    >
      <dxo-header-filter [dataSource]="tagFilterDataSource"></dxo-header-filter>
      <div *dxTemplate="let item of 'tagCellTemplate'">
        <app-task-tags [tags]="item.data.tags" [max]="2" pillMaxWidth="120px"></app-task-tags>
      </div>
    </dxi-column>

    <!----------- Comment Column --------------------------------->
    <dxi-column
      dataField="commentCount"
      i18n-caption="@@notes"
      caption="Notes"
      width="30"
      cellTemplate="noteTemplate"
      headerCellTemplate="headerCellNotes"
      [allowFiltering]="false"
      [allowEditing]="false"
      class="comment"
      [allowResizing]="true"
    >
      <div *dxTemplate="let item of 'headerCellNotes'">
        <i class="dx-icon-overflow"> </i>
      </div>
      <div *dxTemplate="let item of 'noteTemplate'">
        <div
          class="cell-comment-container task-menu-trigger"
          [id]="'task-menu-' + item.data.id"
          (click)="openTaskMenu(item.data)"
        >
          <i *ngIf="item.data.commentCount === 0" class="dx-icon-overflow"> </i>
          <div *ngIf="item.data.commentCount > 0" class="cell-comment tab-comment-counter">
            {{ item.data.commentCount }}
          </div>
        </div>
      </div>
    </dxi-column>

    <!----------- Approve Column --------------------------------->
    <dxi-column caption width="40" cellTemplate="actionTemplate" *ngIf="canApprove()" [allowResizing]="true">
      <div *dxTemplate="let item of 'actionTemplate'">
        <dx-check-box
          *ngIf="item.data.type != 'group'"
          [value]="item.data.status == 4 ? true : false"
          (onValueChanged)="completeTask(item.data)"
          [readOnly]="item.data.status == StatusData.IN_REVIEW.id ? false : true"
          [class.task-complete]="item.data.status == StatusData.DONE.id"
        >
        </dx-check-box>
      </div>
    </dxi-column>
  </dx-tree-list>
</div>


<!-- Task row "..." menu (#4635): the menu is the entry point, the popup opens on the chosen view. -->
<dx-context-menu
  cssClass="task-row-menu"
  [items]="taskMenuItems"
  [target]="taskMenuTarget"
  [(visible)]="taskMenuVisible"
  showEvent="none"
  (onItemClick)="onTaskMenuItemClick($event)"
></dx-context-menu>

<!-- One popup per menu entry, all on the same card (#4635): title bar, body, and a footer that
     fits what the view can do - Notes and History have nothing to confirm. -->
<app-generic-popup
  [visible]="notesPopupVisible"
  (visibleChange)="notesPopupVisible = $event"
  i18n-title="@@notes"
  title="Notes"
  width="700px"
  [buttons]="closeButton"
  (onHiding)="onTaskPopupHiding()"
>
  <app-comment-editor
    *ngIf="commentsEditorVisible"
    (onCommentSaved)="getProjectTaskComments(commentsTaskId)"
    (onCommentDeleted)="getProjectTaskComments(commentsTaskId)"
    [projectId]="projectId"
    [taskId]="commentsTaskId"
  ></app-comment-editor>
  <div *ngIf="!commentsEditorVisible" style="min-height: 300px">&nbsp;</div>
</app-generic-popup>

<app-generic-popup
  [visible]="historyPopupVisible"
  (visibleChange)="historyPopupVisible = $event"
  i18n-title="@@history"
  title="History"
  width="700px"
  [buttons]="closeButton"
>
  <dx-data-grid
    [dataSource]="loggingData"
    class="gt-data-grid-style"
    [rowAlternationEnabled]="true"
    [hoverStateEnabled]="true"
  >
    <dxi-column dataField="log" i18n-caption="@@log" caption="Log"> </dxi-column>
    <dxi-column dataField="previousValue" i18n-caption="@@previousValue" caption="Previous Value"> </dxi-column>
    <dxi-column dataField="newValue" i18n-caption="newValue" caption="New Value"> </dxi-column>
    <dxi-column
      format="dd.MM.yyyy HH:mm"
      dataType="date"
      dataField="dateChanged"
      i18n-caption="@@dateChanged"
      caption="Date Changed"
    >
    </dxi-column>
    <dxi-column dataField="userName" i18n-caption="@@username" caption="Username"> </dxi-column>
  </dx-data-grid>
</app-generic-popup>

<app-generic-popup
  [visible]="notificationsPopupVisible"
  (visibleChange)="notificationsPopupVisible = $event"
  i18n-title="@@notification"
  title="Notification"
  width="500px"
  [buttons]="notificationButtons"
  (onShowing)="onNotificationsPopupShowing()"
>
  <app-task-notifications-panel
    #notificationsPanel
    [projectTaskId]="taskMenuTask?.id ?? null"
    [assignedUserEmail]="taskMenuTask?.assignedUserEmail ?? null"
    [departmentUserEmail]="taskMenuTask?.departmentUserEmail ?? null"
    [departmentName]="lookupDepartment($safeNavigationMigration(taskMenuTask?.departmentId))"
    [departmentHolderId]="taskMenuTask?.departmentUserDepartmentId ?? null"
    [departmentHolderName]="taskMenuTask?.departmentUserDepartmentName ?? null"
    [assignedDepartmentId]="taskMenuTask?.assignedDepartmentId ?? null"
    [assignedDepartmentName]="taskMenuTask?.assignedDepartmentName ?? null"
    [users]="users"
  ></app-task-notifications-panel>
</app-generic-popup>

<app-contacts-popup
  class="dx-treevieweditor-overlay"
  [(visible)]="contactsPopupVisible"
  (onHiding)="contactsPopupVisible = false"
  [(companies)]="companies"
  [(persons)]="persons"
  (onContactSelected)="onPopupContactSelected($event)"
  (onContactAdded)="onNewContactSelected($event)"
>
</app-contacts-popup>

<dx-toast [(visible)]="toastVisible" i18n-message="@@successfullySaved" message="Successfully saved"></dx-toast>

<dx-popup
  [resizeEnabled]="true"
  [dragEnabled]="true"
  [visible]="wikiArticlePopupVisible"
  (onHiding)="wikiArticlePopupVisible = false"
>
  <dx-scroll-view class="scrollable-list" direction="vertical" showScrollbar="always">
    <div *ngIf="article != null">
      <h1>{{ article.title }}</h1>
      <div #articleContainer id="article-container" *ngFor="let paragraph of article.paragraphs">
        <div *ngFor="let block of paragraph.blocks">
          <div [innerHTML]="block.content | safeHTML"></div>
        </div>
      </div>
    </div>
  </dx-scroll-view>
</dx-popup>

<dx-popup
  [resizeEnabled]="true"
  [dragEnabled]="true"
  i18n-title="@@downloadDocuments"
  title="Download Documents"
  width="auto"
  height="auto"
  maxWidth="90%"
  maxHeight="70vh"
  [wrapperAttr]="{ class: 'gpd-popup document-download-popup' }"
  [(visible)]="documentDownloadPanelVisible"
>
  <dxi-popup-toolbar-item widget="dxButton" toolbar="bottom" location="after">
    <app-gpd-button
      i18n-text="@@downloadDocuments"
      text="Download Documents"
      (onClick)="handleDocumentDownloadProceed()"
    ></app-gpd-button>
  </dxi-popup-toolbar-item>

  <div *dxTemplate="let data of 'content'">
    <div class="download-content">
      <p i18n="@@selectDocumentForDownload">Please select the documents that you would like to download:</p>

      <dx-data-grid
        [(selectedRowKeys)]="documentDownloadSelectedRowKeys"
        height="50vh"
        class="gpd-datagrid"
        [dataSource]="documentDownloadData"
        #taskDocumentDownloadList
        keyExpr="id"
        [showRowLines]="true"
        [showBorders]="true"
        loadPanel="visible"
        [hoverStateEnabled]="true"
        [sorting]="false"
        [repaintChangesOnly]="true"
      >
        <dxo-scrolling mode="standard"></dxo-scrolling>
        <dxo-selection
          mode="multiple"
          [showCheckBoxesMode]="'always'"
          [selectByClick]="false"
          [allowSelectAll]="true"
        ></dxo-selection>
        <dxo-paging [pageSize]="10"></dxo-paging>

        <dxi-column
          dataField="title"
          i18n-caption="@@title"
          caption="Title"
          [allowEditing]="false"
          [allowFiltering]="false"
        >
        </dxi-column>

        <dxi-column
          dataField="type"
          i18n-caption="@@type"
          caption="Type"
          [width]="120"
          [allowEditing]="false"
          [lookup]="{
            dataSource: typeLookup,
            displayExpr: 'val',
            valueExpr: 'id',
          }"
        >
        </dxi-column>

        <dxi-column
          dataField="status"
          i18n-caption="@@status"
          caption="Status"
          [width]="200"
          cellTemplate="statusTemplate"
          editCellTemplate="statusEditTemplate"
          [allowFiltering]="false"
        >
          <div *dxTemplate="let item of 'statusTemplate'">
            <app-status-pill [statusId]="item.data.status" [statusConfig]="taskStatusConfig" />
          </div>
        </dxi-column>
      </dx-data-grid>
    </div>
  </div>
</dx-popup>

<dx-popup
  [resizeEnabled]="true"
  [dragEnabled]="true"
  i18n-title="@@selectExportPackage"
  title="Select Export Package"
  width="auto"
  height="auto"
  maxWidth="90%"
  maxHeight="70%"
  [(visible)]="exportPackageSelectionPopupVisible"
>
  <dx-list
    #exportPackageList
    [dataSource]="exportPackages"
    displayExpr="exportPackageTitle"
    height="auto"
    width="500"
    selectionMode="single"
    (onItemClick)="getExportPackageData($event); exportPackageSelectionPopupVisible = false"
  ></dx-list>
</dx-popup>

<app-generic-popup
  [(visible)]="exportGapsVisible"
  [title]="exportGapsTitle"
  titleIcon="alert"
  [width]="640"
  [allowOutsideClick]="false"
  [buttons]="exportGapsButtons"
  (onHiding)="onExportGapsHiding()"
>
  <p class="export-gaps-intro" i18n="@@exportGapsIntro">
    These items of the list are not complete yet. The export contains only what is available and what you have access to.
  </p>
  <details *ngFor="let g of exportGaps; let first = first" class="export-gap-group" [open]="first">
    <summary>
      <app-svg-icon class="export-gap-chevron" icon="chevron-down" [size]="16" color="var(--color-grey-600)"></app-svg-icon>
      <span class="export-gap-title">{{ g.title }}</span>
      <span class="export-gap-count">{{ g.count }}</span>
    </summary>
    <div class="export-gap-body">
      <div *ngFor="let s of g.subgroups" class="export-gap-subgroup">
        <div *ngIf="s.context" class="export-gap-context">{{ s.context }}</div>
        <div *ngFor="let i of s.items" class="export-gap-row">
          <span class="export-gap-label">{{ i.label }}</span>
          <span class="export-gap-badges">
            <span *ngFor="let m of i.missing" class="export-gap-badge">{{ m }}</span>
          </span>
        </div>
      </div>
    </div>
  </details>
</app-generic-popup>

<!-- contract popup -->
<app-contract-selector-popup
  *ngIf="contractsEnabled"
  [visible]="contractSelectorPopupVisible"
  (hidden)="contractSelectorPopupVisible = false"
  (contractSelected)="onContractSelected($event)"
  [createTo]="{ id: $safeNavigationMigration(targetItem?.id), target: 'task' }"
>
</app-contract-selector-popup>

<app-file-viewer #fileviewer></app-file-viewer>

<!-- Reopen Task Reason Popup -->
<app-generic-popup [visible]="currentReopeningTask != null" title="Reopen Task" [buttons]="reopoenPopupButtons">
  <div class="reopen-reason-content">
    <p i18n="@@reopenReasonDescription">Please select a reason for reopening this task:</p>
    <dx-validation-group #statusVal>
      <dx-select-box
        class="gpd-input"
        [(value)]="selectedReopenReasonId"
        [dataSource]="reopenReasons"
        displayExpr="name"
        valueExpr="id"
        [searchEnabled]="true"
      >
        <dx-validator> <dxi-validation-rule type="required"></dxi-validation-rule> </dx-validator
      ></dx-select-box>
    </dx-validation-group>
  </div>
</app-generic-popup>

<!-- #4658: Assign a validator right after a task moves to "In Review" -->
<app-generic-popup
  [visible]="validationTask != null"
  title="Validation Required"
  i18n-title="@@validationRequired"
  titleIcon="alert"
  [buttons]="validationPopupButtons"
  [allowOutsideClick]="false"
  (onHiding)="onValidatorPromptClosed()"
>
  <div class="reopen-reason-content">
    <p i18n="@@validationAssignDescription">This task requires validation. Please assign it to a user:</p>
    <dx-validation-group #validationVal>
      <dx-select-box
        class="gpd-input"
        [(value)]="validationAssignee"
        [dataSource]="validatorUsers"
        displayExpr="displayName"
        valueExpr="emailAddress"
        [searchEnabled]="true"
        searchMode="contains"
      >
        <dx-validator> <dxi-validation-rule type="required"></dxi-validation-rule> </dx-validator>
      </dx-select-box>
    </dx-validation-group>
    <p class="validation-reviewer-hint" i18n="@@validationReviewerHint">
      Only users with review permissions are listed.
    </p>
  </div>
</app-generic-popup>

<app-project-complete-popup
  [(visible)]="projectCompletePopupVisible"
  [userName]="currentUserName"
></app-project-complete-popup>

<!-- #148: automatic document creation -->
<app-fill-template-modal
  [(visible)]="fillTemplateVisible"
  [context]="fillTemplateContext"
  [projectId]="projectId"
  [projectTaskId]="fillTemplateTaskId"
  [taskTemplates]="fillTemplateTaskTemplates"
  [addToContext]="fillTemplateAddHandler"
></app-fill-template-modal>
